/**
 *
 * @param {Tile} t1
 * @param {Tile} t2
 * @returns {number} Largest distance in whichever axis
 */
export function tileDistance(t1, t2) {
  if (!t1 || !t2) return -1;

  return Math.max(
    Math.abs(t1.position.x - t2.position.x),
    Math.abs(t1.position.y - t2.position.y)
  );
}
